// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__uvUAF","productName":"Table_productName__tjMvr"};